import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { initMaps } from './../shared/mapsController'
import { scrollToTarget } from './../shared/scrollTo'


class VenuesController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.maps = initMaps()
    
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
    
  }
  addEventListeners() {
    super.addEventListeners()
    $("body").on("click", ".venue-mapdata", $.proxy(this.onVenueClick, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    $("body").off("click", ".venue-mapdata", $.proxy(this.onVenueClick, this))
  }
  /**
   * ###########
   * ### OWN ###
   */
  onVenueClick(e) {
    e.preventDefault()
    const venue = e.currentTarget
    const id = venue.dataset.id
    if (id) {
      this.maps.forEach((map) => {
        map.openInfoWindowById(id, 15)
        // scroll to map
        scrollToTarget(map.$map.get(0))
      })
    }
  }
  

}

export default VenuesController;